import httpService from './httpService';

export default {
  query,
  downloadReport,
};

function query(filterBy) {
  let filters = [];
  for (let filterKey in filterBy) {
    if (filterBy[filterKey])
      filters.push(filterKey + '=' + filterBy[filterKey]);
  }
  let filterUrlParams = filters.length ? '?' + filters.join('&') : '';
  return httpService.get(`report${filterUrlParams}`);
}
function downloadReport(filterBy) {
  let filters = [];
  for (let filterKey in filterBy) {
    if (filterBy[filterKey])
      filters.push(filterKey + '=' + filterBy[filterKey]);
  }
  let filterUrlParams = filters.length ? '?' + filters.join('&') : '';
  return httpService.customRequest(
    'GET',
    `report/download${filterUrlParams}`,
    null,
    { responseType: 'arraybuffer' },
  );
}
